import { render, staticRenderFns } from "./Caigou.vue?vue&type=template&id=77fa419a&scoped=true"
import script from "./Caigou.vue?vue&type=script&lang=js"
export * from "./Caigou.vue?vue&type=script&lang=js"
import style0 from "./Caigou.vue?vue&type=style&index=0&id=77fa419a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fa419a",
  null
  
)

export default component.exports